var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2002 6.66634H1.2002M9.86686 1.33301V3.99967M4.53353 1.33301V3.99967M4.4002 14.6663H10.0002C11.1203 14.6663 11.6804 14.6663 12.1082 14.4484C12.4845 14.2566 12.7905 13.9506 12.9822 13.5743C13.2002 13.1465 13.2002 12.5864 13.2002 11.4663V5.86634C13.2002 4.74624 13.2002 4.18618 12.9822 3.75836C12.7905 3.38204 12.4845 3.07607 12.1082 2.88433C11.6804 2.66634 11.1203 2.66634 10.0002 2.66634H4.4002C3.28009 2.66634 2.72004 2.66634 2.29221 2.88433C1.91589 3.07607 1.60993 3.38204 1.41818 3.75836C1.2002 4.18618 1.2002 4.74624 1.2002 5.86634V11.4663C1.2002 12.5864 1.2002 13.1465 1.41818 13.5743C1.60993 13.9506 1.91589 14.2566 2.29221 14.4484C2.72004 14.6663 3.28009 14.6663 4.4002 14.6663Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.eaf9960bf173949ef2a599f126d71f0b.svg";
export { ForwardRef as ReactComponent };